import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';
import {ReactiveServiceWithFilters} from '../reactive-service-with-filters.abstract';
import {MultipleRESTService} from '../../../../src/app/API/apiService';
import {SystemEventModel} from './system-event.model';

@Injectable()
export class SystemEventsApiService extends ReactiveServiceWithFilters implements Resolve<SystemEventModel[]>, MultipleRESTService<SystemEventModel[]> {
  protected baseUrl = environment.backEndUrlPrefix + '/' + 'system_event';

  constructor(protected http: HttpClient) {
    super();
  }

  getAll(): Observable<SystemEventModel[]> {
    return this.http.get<SystemEventModel[]>(this.buildUrl(this.baseUrl));
  }

  updateGroup(ids: number[], data): Observable<SystemEventModel[]> {
    return this.http.patch<SystemEventModel[]>(this.baseUrl, data, {params: {id: ids.map(id => id.toString())}});
  }

  deleteGroup(ids: number[]): Observable<string> {
    return this.http.delete<string>(this.baseUrl, {params: {id: ids.map(id => String(id))}});
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<SystemEventModel[]> | Promise<SystemEventModel[]> | SystemEventModel[] {
    return this.getAll();
  }

}
